import { Grid, Stack } from "@mui/material";
import { m } from "framer-motion";
import { useContext } from "react";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../context";
import CrossExitBtn from "./components/CrossExitBtn/CrossExitBtn";
import CustomLogo from "./components/CustomLogo";
import InfoHeader from "./components/InfoHeader/InfoHeader";
import MobileBtn from "./components/MobileBtn";
import InfoItems from "./InfoItems";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	aboutData: string;
};

export const InfoStep = ({ title, aboutData }: Props) => {
	const { theme, isFrame } = useContext(Context);

	const isMobile = useResponsive("down", "sm");
	const isDownMd = useResponsive("down", "md");

	const hasLogo = theme && theme.logo;
	const showExit = theme && theme.showExit;

	return (
		<Stack
			component={m.div}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 1 }}
			width={isDownMd ? "auto" : 800}
			height={isMobile ? "auto" : isFrame ? 380 : 500}
		>
			{!isFrame && hasLogo && <CustomLogo />}
			{!isFrame && showExit && <CrossExitBtn />}
			<Grid
				container
				columnSpacing={4}
				rowSpacing={isMobile ? 2 : hasLogo ? 2 : 4}
				sx={{ mt: isFrame ? 1 : theme && !theme.logo && theme.showExit ? 6 : isMobile ? 0 : 2 }}
			>
				<InfoHeader title={title} />
				<InfoItems aboutData={aboutData} />
			</Grid>
			{isMobile && <MobileBtn />}
		</Stack>
	);
};

export default InfoStep;
